module.exports = __webpack_public_path__ + "img/sleepBreathingMonitor.1bd800c9.png";